import { useQuery } from '@tanstack/react-query';
import { GlobalReactQueryOptions } from '../../config';
import { fetchSubscriptionPeriods } from './fetchSubscriptionPeriods';

const SUBSCRIPTION_PERIODS = `subscriptionPeriods`;

export const useSubscriptionPeriods = () => {
    return useQuery([SUBSCRIPTION_PERIODS], fetchSubscriptionPeriods, {
        ...GlobalReactQueryOptions,
        staleTime: 5 * 60 * 1000
    });
};
